import { defineMessages } from 'react-intl';
import { generatePath } from 'react-router-dom';
import styled from 'styled-components';

import { SBHorizontal } from '@sorare/core/src/atoms/layout/flex';
import { SHARING_ORIGIN } from '@sorare/core/src/config';
import { NBA_LEAGUES_JOIN_LEAGUESLUG } from '@sorare/core/src/constants/__generated__/routes';

import { CopyButton } from './CopyButton';

export const generateUserGroupInviteLink = (
  joinSecret: string,
  userSlug?: string
) => {
  let link =
    SHARING_ORIGIN +
    generatePath(NBA_LEAGUES_JOIN_LEAGUESLUG, {
      leagueSlug: joinSecret,
    });
  if (userSlug) {
    link = `${link}?referrer=${userSlug}`;
  }
  return link;
};

const Wrapper = styled(SBHorizontal).attrs({ gap: 2 })`
  border-radius: var(--double-unit);
  background-color: var(--c-neutral-400);
  padding: var(--half-unit) var(--unit);
  font: var(--t-14);
  font-weight: var(--t-bold);
  color: var(--c-neutral-1000);
  overflow: hidden;
`;
const OpacityFilter = styled.span`
  opacity: 0.6;
  white-space: nowrap;
  overflow-x: auto;
`;

export const messages = defineMessages({
  inviteTitle: {
    id: 'UserGroupInvitation.Field.Share',
    defaultMessage: 'Invite',
  },
});

type Props = { inviteLink: string };
export const InviteLinkField = ({ inviteLink }: Props) => {
  return (
    <Wrapper>
      <OpacityFilter>{inviteLink.replace(/^https?:\/\//, '')}</OpacityFilter>
      <CopyButton textToCopy={inviteLink} />
    </Wrapper>
  );
};
